import {Component, Inject, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {DataService} from "../../../../services/data.service";
import {GlobalConstants} from '../../../../common/global-constants';
import {ConfigurationService} from "../../../../services/configuration.service";
import {AuthenticationService} from "../../../../services/authentication.service";
import {validApprover} from "../../../../services/validation.service";
import {CommonUtils} from "../../../../utils/common.utils";


@Component({
  selector: 'app-component-key-onboarding',
  templateUrl: './transit-time-onboarding.component.html',
  styleUrls: ['./transit-time-onboarding.component.scss']
})
export class TransitTimeOnboardingComponent implements OnInit {

  transitTimeOnboardingURL: string = GlobalConstants.PROCESS_TRANSIT_TIME_REQUEST_ENDPOINT;
  transitTimeOnboardingForm: FormGroup;

  fromCountryCodeOptions: any[];
  transitTimeOptions: any[];

  transitTimeConfigurations: any[];
  currentWorkingRecord: any;

  currentComponentKeyPlaceholder = [];
  selectedFile: File = null;

  loading = false;

  patternOptions: any[];

  help_messages: any = this.dataService.help_messages;

  items: any;

  single = GlobalConstants.SINGLE_KEYWORD;
  range = GlobalConstants.RANGE_KEYWORD;
  singleTransitTimeColumns = [];
  rangeTransitTimeColumns = [];

  user = {};

  get progress() {
    return this.uploadFileServiceUtils.progress;
  }

  constructor(@Inject('RequestsService') private requestsService,
              @Inject('UploadFileServiceUtils') private uploadFileServiceUtils,
              @Inject('ConfigurationService') private readonly configurationService: ConfigurationService,
              @Inject('CommonUtils') public readonly commonUtils: CommonUtils,
              @Inject('AuthenticationService') private readonly authenticationService: AuthenticationService,
              private formBuilder: FormBuilder,
              private toastrService: ToastrService,
              private dataService: DataService) {}

  ngOnInit(): void {
    this.user = this.authenticationService.getUserDetails();
    this.transitTimeOnboardingForm = this.formBuilder.group({
      businessUseCase: ['', Validators.required],
      fromCountryCode: ['', Validators.required],
      componentKeyPlaceholder: [''],
      componentKeyValue: this.getComponentKeyValueFormGroup(),
      lookUpKeys: this.formBuilder.array([], [Validators.required]
      ),
      transitTimeType: ['', Validators.required],
      transitTimeFile: ['', Validators.required]
    });
    this.fromCountryCodeOptions = this.commonUtils.getFromCountryCodes();
    this.transitTimeOptions = this.dataService.transitTimeOptionsForOnboarding;
    this.patternOptions = this.dataService.patternOptions;

    this.items = this.commonUtils.getItemsBasedOnArc();
  }

  get getItems(){
    return this.commonUtils.getItemsBasedOnArc()
  }

  onBusinessUseCaseChange(businessUseCase) {
    this.currentWorkingRecord = this.commonUtils.getCurrentWorkingRecord(businessUseCase);

    this.transitTimeOnboardingForm.get(GlobalConstants.COMPONENT_KEY_PLACE_HOLDER).setValue(this.currentWorkingRecord[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER])
    this.currentComponentKeyPlaceholder = this.currentWorkingRecord[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER].split(GlobalConstants.COMPONENT_KEY_VALUE_SEPARATOR);
    this.transitTimeOnboardingForm.setControl(GlobalConstants.COMPONENT_KEY_VALUE, this.getComponentKeyValueFormGroup());

    let lookUpKeyColumns = this.commonUtils.generateLookUpKeyColumns(this.currentWorkingRecord);
    this.singleTransitTimeColumns = lookUpKeyColumns[GlobalConstants.SINGLE_TRANSIT_TIME_COLUMNS];
    this.rangeTransitTimeColumns = lookUpKeyColumns[GlobalConstants.RANGE_TRANSIT_TIME_COLUMNS];

    this.transitTimeOnboardingForm.get(GlobalConstants.TRANSIT_TIME_TYPE).setValue('');
    this.transitTimeOnboardingForm.get(GlobalConstants.TRANSIT_TIME_FILE).setValue('');

    this.transitTimeOnboardingForm.setControl(GlobalConstants.LOOK_UP_KEYS, this.formBuilder.array([], [Validators.required]));
    for (let lookUpKey of this.currentWorkingRecord[GlobalConstants.LOOK_UP_KEYS]) {
      let isRegexPresent = GlobalConstants.LOOK_UP_KEYS_REGEX in lookUpKey;
      this.addLookUpKey(lookUpKey[GlobalConstants.LOOK_UP_KEYS_KEY_NAME], isRegexPresent ? this.dataService.getPatternFromRegex(lookUpKey[GlobalConstants.LOOK_UP_KEYS_REGEX]) : '');
    }
  }

  private getComponentKeyValueFormGroup() {
    let componentKeyPlaceValueFormGroupInput = {};
    for (let componentKey of this.currentComponentKeyPlaceholder) {
      componentKeyPlaceValueFormGroupInput[componentKey] = new FormControl('', Validators.required)
    }
    return this.formBuilder.group(componentKeyPlaceValueFormGroupInput);
  }

  public onFileChange(event) {
    this.selectedFile = event.target.files[0];
  }

  private getLookUpKeyFormGroup(current_count: number, value: string = '', regex: string = ''): FormGroup {
    return this.formBuilder.group({
      order: [current_count + GlobalConstants.ONE],
      name: [value, Validators.required],
      regex: [regex]
    })
  }

  private addLookUpKey(value: string = '', regex: string = '') {
    let currentLookUpKeysFormArray = (<FormArray>this.transitTimeOnboardingForm.get(GlobalConstants.LOOK_UP_KEYS));
    let currentNumberOfLookUpKeys = currentLookUpKeysFormArray.length;
    currentLookUpKeysFormArray.push(this.getLookUpKeyFormGroup(currentNumberOfLookUpKeys, value, regex));
  }


  public async submit() {

    // Creating Request Body
    let requestBody = JSON.parse(JSON.stringify(this.transitTimeOnboardingForm.value));
    let uploadBucket = this.commonUtils.getUploadBucket();

    requestBody[GlobalConstants.ARC] = this.commonUtils.getArc();
    requestBody[GlobalConstants.BUSINESS_UNIT] = this.currentWorkingRecord[GlobalConstants.BUSINESS_UNIT];
    requestBody[GlobalConstants.COMPONENT_KEY_VALUE] = this.commonUtils.buildComponentKeyValue(requestBody[GlobalConstants.COMPONENT_KEY_VALUE], requestBody[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER]);
    let lookUpKeys = requestBody[GlobalConstants.LOOK_UP_KEYS];
    for (let lookUpkeyIndex in lookUpKeys) {
      requestBody[GlobalConstants.LOOK_UP_KEYS][lookUpkeyIndex][GlobalConstants.LOOK_UP_KEYS_REGEX] = this.dataService.getRegexFromPattern(lookUpKeys[lookUpkeyIndex][GlobalConstants.LOOK_UP_KEYS_REGEX]);
    }
    let componentKeyValue = requestBody[GlobalConstants.COMPONENT_KEY_VALUE].replace(GlobalConstants.COMPONENT_KEY_VALUE_SEPARATOR, GlobalConstants.SLASH);
    let key = requestBody[GlobalConstants.TRANSIT_TIME_TYPE] + GlobalConstants.SLASH + requestBody[GlobalConstants.BUSINESS_UNIT] + GlobalConstants.SLASH + requestBody[GlobalConstants.FROM_COUNTRY_CODE] + GlobalConstants.SLASH + componentKeyValue + GlobalConstants.SLASH + Math.round(Date.now() / 1000);
    requestBody[GlobalConstants.BUCKET] = uploadBucket;
    requestBody[GlobalConstants.KEY] = key;
    requestBody[GlobalConstants.CREATED_BY] = this.user[GlobalConstants.ALIAS];
    delete requestBody[GlobalConstants.TRANSIT_TIME_FILE];
    console.log(JSON.stringify(requestBody));

    try {
      this.loading = true;
      const hasPermission = await this.dataService.checkUserPermissions(requestBody);
      this.loading = false;
      if (hasPermission === false){
        this.toastrService.error(GlobalConstants.NO_PERMISSION_MSG, GlobalConstants.TITLE_ERROR);
        return;
      }
    } catch (error) {
      this.loading = false;
      console.error(GlobalConstants.CHECK_USER_PERMISSIONS_ERROR, error)
      this.toastrService.error(GlobalConstants.SOMETHING_WENT_WRONG, GlobalConstants.TITLE_ERROR);
      return;
    }
    let metadata = this.commonUtils.generateMetadata(requestBody);
    // File Upload and call backend apis
    let promise = (this.uploadFileServiceUtils.uploadFile(uploadBucket, key, this.selectedFile, metadata));
    this.loading = true;
    await promise.then((data) => {
      this.loading = false;
      this.toastrService.success(GlobalConstants.FILE_UPLOAD_SUCCESSFUL, GlobalConstants.TITLE_SUCCESS);
    }).catch((data) => {
      this.loading = false;
      this.toastrService.error(GlobalConstants.FILE_UPLOAD_FAILED, GlobalConstants.TITLE_ERROR);
      console.log(data)
    });
    
  }
}
